/* eslint-disable consistent-return */
import axios from 'axios';
import queryStringParser from 'query-string';
import { API_ROOT } from '../config/appConfig';
import { getHeaders } from '../actions/helper.action';

// User-management server, same path shape as the organizations endpoint in
// ./organizations.js. Declared here so a path change is a single-line edit.
const GROUPS_PATH = `${API_ROOT}/user-management/admin/groups`;

// Lists the groups the caller is allowed to see; the backend scopes the result
// from the bearer token, so every role uses this same endpoint.
// Accepts either { results: [{ id, name }] } or a bare [{ id, name }].
export const getGroupListApi = async (filters, jwt) => {
  try {
    const filterString = filters ? `?${queryStringParser.stringify(filters)}` : '';
    const res = await axios.get(
      `${GROUPS_PATH}${filterString}`,
      getHeaders('application/json', jwt)
    );

    if (res.status === 200) {
      return res.data;
    }
  } catch (err) {
    console.error(err);
  }
};
